<template>
  <modal-template ref="modal">
    <template v-slot:title>
      {{ lang.modals.single_maps_location.headline }}
    </template>

    <template v-slot:default>
      <google-maps :location-data="modalData.locationData"></google-maps>
    </template>

    <template v-slot:footer="footerSlotProps">
      <plain-button @click="hideModal">{{
        lang.labels.close
      }}</plain-button>
    </template>
  </modal-template>
</template>

<script setup>
import { ref } from 'vue';
import ModalTemplate from "./ModalTemplate";
import PlainButton from "../buttons/PlainButton";

// COMPONENT PROPS
defineProps({
  lang: Object,
  modalData: Object,
});

// TEMPLATE REFS
const modal = ref(null);

// METHODS
const showModal = () => {
  modal.value.showModal();
};

const hideModal = () => {
  modal.value.hideModal();
};

// EXPOSE METHODS FOR PARENT COMPONENTS
defineExpose({
  showModal,
  hideModal,
});
</script>
